import styled from "styled-components";
import { useEffect, useState } from "react";
import { GoTrash } from "react-icons/go";

import Overlay from "../Overlay";
import Modal from "../Utils/Modal";
import useApi from "../../hooks/useApi";
import { useModal } from "../../contexts/ModalContext";

import ModalNovoEmailTransferencia from "./ModalNovoEmailTransferencia";
import ConfirmDeleteEmailTransferencia from "./ConfirmDeleteEmailTransferencia";
import { useMemo } from "react";

const Header = styled.div`
    width: 100%;
    display: flex;
    margin-bottom: 15px;
    align-items: center;
`;
const Titulo = styled.h2`
    margin: 0;
    font-size: 16px;
    color: #333;
`;
const BotaoAdicionar = styled.button`
    background-color: #2563eb;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    padding: 10px 12px;
    margin-left: auto;
    transition: 0.2s all ease;
    &:hover {
        background-color: #1e40af;
    }
`;
const Container = styled.div`
    width: 100%;
    max-height: 350px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    overflow-y: auto;
`;
const Tabela = styled.table`
    width: 100%;
    border-collapse: collapse;
    thead tr {
        background-color: #f0f0f0;
        height: 40px;
        th {
            padding: 0 15px;
            font-size: 12px;
            font-weight: bold;
            text-align: left;
            color: #333;
        }
    }
    tbody tr {
        height: 40px;
        &:nth-child(even) { background-color: #fafafa; }
        &:nth-child(odd) { background-color: #fff; }
        td {
            padding: 0 15px;
            font-size: 12px;
            color: #333;
        }
        &:hover { background-color: #e0f7fa; }
    }
`;
const ColunaAcoes = styled.td`
    width: 65px;
`;
const IconesWrapper = styled.div`
    width: 65px;
`;
const Lixeira = styled(GoTrash)`
    height: 20px;
    width: 20px;
    color: #e11d48;
    cursor: pointer;
    transition: 0.2s all ease;
    &:hover { color: #b91c1c; }
`;

const FilterBox = styled.div`
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    input {
        flex: 1;
        padding: 8px 10px;
        border: 1px solid #d1d5db;
        border-radius: 6px;
        font-size: 13px;
        outline: none;
        &:focus { border-color: #2563eb; }
    }
`;

const MODAL_ADD = "modalAddEmailTransferencia";
const MODAL_DELETE = "modalDeleteEmailTransferencia";

const ModalEmailsTransferencia = ({ obras, onClose }) => {

    const api = useApi();
    const { isModalOpen, openModal, closeModal } = useModal();

    const [emails, setEmails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [ccFilter, setCcFilter] = useState("");

    const emailsFiltrados = useMemo(() => {
        const term = ccFilter.trim().toLowerCase();
        if (term === "") return emails;
        return emails.filter((row) => {
            return (
                String(row.cc ?? "").toLowerCase().includes(term) ||
                String(row.nome ?? "").toLowerCase().includes(term) ||
                String(row.email ?? "").toLowerCase().includes(term)
            );
        });
    }, [emails, ccFilter]);

    const fetchData = async () => {

        setLoading(true);

        try {

            const { data } = await api.get('/Painel/API/Transferencia/GetEmails/');
            setEmails(Array.isArray(data) ? data : []);

        } catch (e) {

            console.log(e);
            setEmails([]);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [selectedId, setSelectedId] = useState(null);

    const handleDelete = (id) => {
        setSelectedId(id);
        openModal(MODAL_DELETE);
    };

    const handleCancelDelete = () => {
        setSelectedId(null);
        closeModal();
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            closeModal();
        }
    };

    return (
        <>
            <Overlay state={true}>
                <Modal header size="lg" close={handleClose}>
                    <Header>
                        <Titulo>GERENCIAR E-MAILS DE TRANSFERÊNCIA</Titulo>
                        <BotaoAdicionar onClick={() => openModal(MODAL_ADD)}>
                            ADICIONAR E-MAIL
                        </BotaoAdicionar>
                    </Header>
                    <FilterBox>
                        <input
                            type="text"
                            placeholder="Filtrar por CC, nome ou e-mail..."
                            value={ccFilter}
                            onChange={(e) => setCcFilter(e.target.value)}
                        />
                    </FilterBox>
                    <Container>
                        <Tabela>
                            <thead>
                                <tr>
                                    <th>CC</th>
                                    <th>NOME</th>
                                    <th>E-MAIL</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: "center" }}>
                                            CARREGANDO...
                                        </td>
                                    </tr>
                                ) : emailsFiltrados.length === 0 ? (
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: "center" }}>
                                            {emails.length === 0
                                                ? "NENHUM E-MAIL CADASTRADO"
                                                : "NENHUM REGISTRO PARA O FILTRO"}
                                        </td>
                                    </tr>
                                ) : (
                                    emailsFiltrados.map((row) => (
                                        <tr key={row.id}>
                                            <td>{row.cc}</td>
                                            <td>{row.nome}</td>
                                            <td>{row.email}</td>
                                            <ColunaAcoes>
                                                <IconesWrapper>
                                                    <Lixeira onClick={() => handleDelete(row.id)} />
                                                </IconesWrapper>
                                            </ColunaAcoes>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Tabela>
                    </Container>
                </Modal>
            </Overlay>
            {isModalOpen(MODAL_ADD) && (
                <ModalNovoEmailTransferencia obras={obras} fetchData={fetchData} />
            )}
            {isModalOpen(MODAL_DELETE) && (
                <ConfirmDeleteEmailTransferencia
                    id={selectedId}
                    fecharModal={handleCancelDelete}
                    onDelete={fetchData}
                />
            )}
        </>
    );

};

export default ModalEmailsTransferencia;
